import { useState } from 'react';

type State =
  | {
      current: 'idle' | 'search' | 'success';
      companyUniqueSymbol?: undefined;
    }
  | {
      current: 'confirm';
      companyUniqueSymbol: string;
    };

export const useMatchingMachine = () => {
  const [state, send] = useState<State>({
    current: 'idle',
    companyUniqueSymbol: undefined,
  });

  return [state, send] as const;
};
